export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
}

export interface Video {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
  description: string;
  tags: string[];
  releaseDate: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories: VideoCategory[] = [
  { slug: "dianshiju", name: "电视剧", icon: "ri-tv-line" },
  { slug: "dianying", name: "电影", icon: "ri-movie-line" },
  { slug: "zongyi", name: "综艺", icon: "ri-live-line" },
  { slug: "dongman", name: "动漫", icon: "ri-emotion-laugh-line" },
  { slug: "jilupian", name: "纪录片", icon: "ri-vidicon-line" },
  { slug: "shaoer", name: "少儿", icon: "ri-rocket-line" },
  { slug: "duanju", name: "短剧", icon: "ri-smartphone-line" },
  { slug: "tiyu", name: "体育", icon: "ri-football-line" },
];

export const videos: Video[] = [
  {
    id: "v001",
    title: "长安十二时辰",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20scene%20with%20warriors%20in%20armor%20standing%20on%20city%20walls%20at%20sunset%2C%20epic%20cinematic%20lighting%2C%20Tang%20dynasty%20architecture%2C%20dramatic%20clouds%2C%20film%20poster%20style&width=640&height=360&seq=video-thumb-001&orientation=landscape",
    duration: "48集全",
    views: "12.8亿",
    rating: 9.2,
    description: "唐朝天宝三年，上元节前夕，长安城陷入一场惊天危机。死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安。剧情紧凑，制作精良，被誉为国产古装剧的巅峰之作。",
    tags: ["古装", "悬疑", "历史", "动作"],
    releaseDate: "2024-03-15",
    isHot: true,
    isNew: false,
  },
  {
    id: "v002",
    title: "流浪地球3",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20space%20station%20with%20a%20giant%20planet%20in%20the%20background%2C%20spaceships%20departing%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20movie%20poster%20style%2C%20epic%20scale&width=640&height=360&seq=video-thumb-002&orientation=landscape",
    duration: "2:28:15",
    views: "35.6亿",
    rating: 8.9,
    description: "太阳急速老化，持续膨胀，一百年后将吞没地球。人类在地球表面建造了一万座行星发动机，推动地球离开太阳系，开启长达2500年的星际流浪之旅。",
    tags: ["科幻", "灾难", "冒险", "特效"],
    releaseDate: "2025-01-28",
    isHot: true,
    isNew: true,
  },
  {
    id: "v003",
    title: "乘风破浪的姐姐第五季",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Stage%20performance%20with%20spotlights%20and%20colorful%20laser%20effects%2C%20female%20performers%20on%20stage%2C%20audience%20cheering%2C%20variety%20show%20atmosphere%2C%20bright%20and%20energetic%2C%20entertainment%20show&width=640&height=360&seq=video-thumb-003&orientation=landscape",
    duration: "更新至第8期",
    views: "8.2亿",
    rating: 8.5,
    description: "30位30+姐姐重新出发，通过封闭式训练和舞台竞演，最终选出优秀姐姐成团出道。本季赛制全面升级，舞台更加华丽。",
    tags: ["综艺", "竞演", "女团", "音乐"],
    releaseDate: "2025-06-10",
    isHot: true,
    isNew: true,
  },
  {
    id: "v004",
    title: "深海寻踪",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20style%20underwater%20scene%20with%20colorful%20coral%20reefs%20and%20mysterious%20deep%20ocean%20creatures%2C%20a%20young%20explorer%20character%2C%20beautiful%20blue%20and%20teal%20color%20palette%2C%20cinematic%20anime%20art&width=640&height=360&seq=video-thumb-004&orientation=landscape",
    duration: "更新至56话",
    views: "5.7亿",
    rating: 9.0,
    description: "少年林深海在一次意外中获得了与海洋生物沟通的能力，从此踏上了探索深海奥秘的冒险之旅。精美画面，感人故事，国产动画新标杆。",
    tags: ["奇幻", "冒险", "热血", "国产"],
    releaseDate: "2024-09-01",
    isHot: false,
    isNew: false,
  },
  {
    id: "v005",
    title: "地球脉动：蓝色海洋",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20underwater%20wildlife%20documentary%20scene%20with%20whales%20and%20dolphins%20swimming%20in%20crystal%20clear%20deep%20blue%20ocean%2C%20sunlight%20rays%20penetrating%20water%2C%20nature%20documentary%20cinematography&width=640&height=360&seq=video-thumb-005&orientation=landscape",
    duration: "6集全",
    views: "3.4亿",
    rating: 9.7,
    description: "深入海洋深处，揭示从未被拍摄过的海洋生物奇观。从珊瑚礁到深海海沟，每一帧都是视觉盛宴。",
    tags: ["自然", "海洋", "BBC", "4K"],
    releaseDate: "2025-04-22",
    isHot: false,
    isNew: true,
  },
  {
    id: "v006",
    title: "小猪佩奇大冒险",
    category: "shaoer",
    thumbnail: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20farm%20scene%20with%20colorful%20houses%20and%20green%20hills%2C%20happy%20animal%20characters%20playing%20together%2C%20bright%20and%20cheerful%20children%20animation%20style%2C%20sunny%20day&width=640&height=360&seq=video-thumb-006&orientation=landscape",
    duration: "52集全",
    views: "28.9亿",
    rating: 8.8,
    description: "小猪佩奇和她的家人朋友们一起探险、学习、成长。寓教于乐，全球最受欢迎的学龄前动画之一。",
    tags: ["益智", "亲子", "动画", "启蒙"],
    releaseDate: "2024-06-01",
    isHot: true,
    isNew: false,
  },
  {
    id: "v007",
    title: "卧虎藏龙之暗影",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20film%20scene%20with%20two%20warriors%20fighting%20on%20bamboo%20trees%20in%20misty%20mountains%2C%20elegant%20wuxia%20aesthetic%2C%20flowing%20robes%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere&width=640&height=360&seq=video-thumb-007&orientation=landscape",
    duration: "2:05:42",
    views: "18.3亿",
    rating: 8.7,
    description: "江湖再起波澜，一把传说中的宝剑重现人间。各路高手齐聚，一场关于荣誉与背叛的传奇故事就此展开。",
    tags: ["武侠", "动作", "古装", "江湖"],
    releaseDate: "2025-02-14",
    isHot: false,
    isNew: false,
  },
  {
    id: "v008",
    title: "极限挑战第十季",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20challenge%20show%20scene%20with%20group%20of%20people%20doing%20fun%20tasks%20in%20a%20colorful%20city%20street%2C%20team%20spirit%2C%20laughter%2C%20variety%20entertainment%20atmosphere&width=640&height=360&seq=video-thumb-008&orientation=landscape",
    duration: "更新至第6期",
    views: "6.9亿",
    rating: 8.3,
    description: "极限男人帮再次集结，全新城市挑战赛制，更多爆笑任务等你来看。",
    tags: ["真人秀", "挑战", "搞笑", "户外"],
    releaseDate: "2025-07-05",
    isHot: true,
    isNew: true,
  },
  {
    id: "v009",
    title: "繁花似锦",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20scene%20in%20Shanghai%20street%20at%20night%20with%20neon%20lights%20and%20fashionable%20people%2C%20romantic%20atmosphere%2C%20city%20skyline%2C%20warm%20tones%2C%20film%20poster%20style&width=640&height=360&seq=video-thumb-009&orientation=landscape",
    duration: "36集全",
    views: "22.1亿",
    rating: 9.1,
    description: "九十年代的上海，机遇与挑战并存。几个年轻人的命运在时代的浪潮中交织，演绎一段关于爱情、梦想与奋斗的都市传奇。",
    tags: ["都市", "爱情", "励志", "年代"],
    releaseDate: "2024-11-08",
    isHot: true,
    isNew: false,
  },
  {
    id: "v010",
    title: "美食大冒险之舌尖寻味",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20dishes%20on%20a%20traditional%20wooden%20table%2C%20chef%20cooking%20in%20a%20rustic%20kitchen%2C%20warm%20lighting%2C%20appetizing%20food%20photography%2C%20cultural%20atmosphere&width=640&height=360&seq=video-thumb-010&orientation=landscape",
    duration: "12集全",
    views: "15.7亿",
    rating: 9.4,
    description: "走遍中国大江南北，探寻最地道的美食文化。从街边小吃到宫廷御膳，每一道菜背后都有一个动人的故事。",
    tags: ["美食", "文化", "旅行", "人文"],
    releaseDate: "2025-03-20",
    isHot: false,
    isNew: false,
  },
  {
    id: "v011",
    title: "超级飞侠大电影",
    category: "shaoer",
    thumbnail: "https://readdy.ai/api/search-image?query=Cute%203D%20animated%20airplane%20characters%20flying%20over%20colorful%20city%20skyline%2C%20happy%20and%20adventurous%20children%20animation%20style%2C%20bright%20blue%20sky%20with%20fluffy%20clouds%2C%20family-friendly&width=640&height=360&seq=video-thumb-011&orientation=landscape",
    duration: "1:32:18",
    views: "9.5亿",
    rating: 8.6,
    description: "乐迪和他的超级飞侠朋友们接到了一项全球救援任务，他们将飞往世界各地，帮助小朋友们解决困难。",
    tags: ["动画", "冒险", "教育", "友情"],
    releaseDate: "2025-06-01",
    isHot: false,
    isNew: true,
  },
  {
    id: "v012",
    title: "大明风华之永乐盛世",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Ming%20dynasty%20imperial%20palace%20interior%20with%20emperor%20in%20golden%20dragon%20robe%20sitting%20on%20throne%2C%20ornate%20Chinese%20architecture%2C%20dramatic%20lighting%2C%20historical%20epic%20film%20poster%20style&width=640&height=360&seq=video-thumb-012&orientation=landscape",
    duration: "60集全",
    views: "19.6亿",
    rating: 8.8,
    description: "以明朝永乐年间为背景，讲述朱棣迁都北京后的朝堂风云与家国天下。宏大的历史叙事，精美的服化道制作。",
    tags: ["历史", "宫廷", "权谋", "史诗"],
    releaseDate: "2024-08-18",
    isHot: false,
    isNew: false,
  },
  {
    id: "v013",
    title: "开心麻花之乌龙特工",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Comedy%20spy%20movie%20scene%20with%20two%20mismatched%20agents%20in%20suits%20running%20through%20a%20modern%20office%20building%2C%20chaotic%20and%20funny%20situation%2C%20bright%20lighting%2C%20action%20comedy%20style&width=640&height=360&seq=video-thumb-013&orientation=landscape",
    duration: "1:48:36",
    views: "11.2亿",
    rating: 7.9,
    description: "一个普通公司职员误打误撞卷入一场国际间谍阴谋，与一名真正的特工组成奇葩搭档。笑料百出的动作喜剧。",
    tags: ["喜剧", "动作", "间谍", "搞笑"],
    releaseDate: "2025-05-01",
    isHot: false,
    isNew: true,
  },
  {
    id: "v014",
    title: "短剧精选：重生之都市修仙",
    category: "duanju",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20city%20street%20at%20night%20with%20a%20mysterious%20figure%20surrounded%20by%20glowing%20energy%2C%20urban%20fantasy%20style%2C%20neon%20lights%2C%20dramatic%20contrast%2C%20web%20series%20aesthetic&width=640&height=360&seq=video-thumb-014&orientation=landscape",
    duration: "80集全",
    views: "7.8亿",
    rating: 8.1,
    description: "修仙界第一高手渡劫失败，重生回到都市校园时代。这一次，他要弥补所有遗憾，守护身边的人。",
    tags: ["都市", "修仙", "重生", "爽文"],
    releaseDate: "2025-04-15",
    isHot: true,
    isNew: true,
  },
  {
    id: "v015",
    title: "灌篮高手：全国大赛篇",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20basketball%20game%20scene%20with%20intense%20action%20on%20the%20court%2C%20players%20jumping%20for%20dunk%2C%20dramatic%20lighting%2C%20sports%20anime%20style%2C%20excited%20crowd%20in%20background&width=640&height=360&seq=video-thumb-015&orientation=landscape",
    duration: "更新至24话",
    views: "16.4亿",
    rating: 9.5,
    description: "湘北高中篮球队终于打进全国大赛，面对全国最强的山王工业，他们能否创造奇迹？经典篮球动画热血归来。",
    tags: ["体育", "篮球", "热血", "经典"],
    releaseDate: "2024-12-01",
    isHot: true,
    isNew: false,
  },
  {
    id: "v016",
    title: "NBA总决赛2025精彩回顾",
    category: "tiyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20in%20a%20packed%20arena%20with%20bright%20stadium%20lights%2C%20player%20making%20a%20spectacular%20dunk%2C%20intense%20sports%20atmosphere%2C%20championship%20game&width=640&height=360&seq=video-thumb-016&orientation=landscape",
    duration: "1:56:30",
    views: "5.3亿",
    rating: 9.0,
    description: "2025年NBA总决赛全程精彩回顾，感受篮球最高殿堂的激烈对抗与巅峰对决。",
    tags: ["NBA", "篮球", "体育", "决赛"],
    releaseDate: "2025-06-30",
    isHot: false,
    isNew: true,
  },
  {
    id: "v017",
    title: "短剧精选：霸道总裁爱上我",
    category: "duanju",
    thumbnail: "https://readdy.ai/api/search-image?query=Luxurious%20modern%20office%20with%20floor-to-ceiling%20windows%20overlooking%20city%2C%20a%20handsome%20man%20in%20designer%20suit%2C%20romantic%20drama%20atmosphere%2C%20soft%20warm%20lighting%2C%20web%20series%20style&width=640&height=360&seq=video-thumb-017&orientation=landscape",
    duration: "60集全",
    views: "6.5亿",
    rating: 7.8,
    description: "平凡女孩意外闯入霸道总裁的世界，两人从互看不顺眼到相知相爱。甜宠短剧，轻松解压。",
    tags: ["甜宠", "都市", "短剧", "爱情"],
    releaseDate: "2025-05-20",
    isHot: true,
    isNew: false,
  },
  {
    id: "v018",
    title: "世界建筑奇观",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=World%20famous%20landmarks%20and%20stunning%20architecture%20from%20different%20countries%2C%20Eiffel%20Tower%20and%20Taj%20Mahal%20side%20by%20side%2C%20golden%20hour%20lighting%2C%20travel%20documentary%20style&width=640&height=360&seq=video-thumb-018&orientation=landscape",
    duration: "10集全",
    views: "2.8亿",
    rating: 9.1,
    description: "横跨六大洲，探访人类建筑史上的奇迹。从金字塔到埃菲尔铁塔，感受建筑之美与人类智慧的结晶。",
    tags: ["建筑", "历史", "旅行", "文化"],
    releaseDate: "2025-02-10",
    isHot: false,
    isNew: false,
  },
  {
    id: "v019",
    title: "汪汪特工队",
    category: "shaoer",
    thumbnail: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20dogs%20in%20hero%20costumes%20ready%20for%20adventure%2C%20colorful%20city%20background%2C%20fun%20and%20playful%20children%20animation%20style%2C%20team%20of%20animal%20heroes&width=640&height=360&seq=video-thumb-019&orientation=landscape",
    duration: "40集全",
    views: "14.2亿",
    rating: 8.4,
    description: "一群可爱的小狗组成的救援队，随时准备帮助遇到困难的人们。团队合作，勇敢无畏。",
    tags: ["动画", "冒险", "团队", "勇气"],
    releaseDate: "2024-10-15",
    isHot: false,
    isNew: false,
  },
  {
    id: "v020",
    title: "密室大逃脱第五季",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20escape%20room%20with%20eerie%20lighting%20and%20puzzle%20elements%2C%20group%20of%20people%20solving%20clues%20together%2C%20thrilling%20atmosphere%2C%20variety%20show%20entertainment&width=640&height=360&seq=video-thumb-020&orientation=landscape",
    duration: "更新至第10期",
    views: "9.1亿",
    rating: 8.6,
    description: "明星嘉宾被困在密室中，需要在限定时间内破解谜题逃离。烧脑推理，爆笑不断。",
    tags: ["密室", "推理", "悬疑", "真人秀"],
    releaseDate: "2025-06-20",
    isHot: true,
    isNew: true,
  },
];

export const hotVideos = videos.filter((v) => v.isHot).slice(0, 8);
export const newVideos = videos.filter((v) => v.isNew).slice(0, 8);

export function getVideosByCategory(slug: string): Video[] {
  return videos.filter((v) => v.category === slug);
}

export function getVideoById(id: string): Video | undefined {
  return videos.find((v) => v.id === id);
}

export function getRelatedVideos(video: Video, count: number = 6): Video[] {
  return videos
    .filter((v) => v.id !== video.id && (v.category === video.category || v.tags.some((t) => video.tags.includes(t))))
    .slice(0, count);
}